var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUndergroundActivity = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.094 19.324 14.444 2.103a1.03 1.03 0 0 0-1.749 0L2.045 19.324c-.423.685.07 1.569.875 1.569h21.3c.805 0 1.298-.884.874-1.569M15.059 17.56a1.56 1.56 0 0 1-3.12 0v-.014a1.56 1.56 0 0 1 3.12 0zm0-4.197a1.56 1.56 0 0 1-3.12 0v-6.27a1.56 1.56 0 0 1 3.12 0z"
  })));
};
export default SvgUndergroundActivity;